import { type DocumentNode, gql } from '@apollo/client';

/**
 * Variables for createSharedLink mutation
 */
export interface CreateSharedLinkVariables {
  viewLimit?: number;
  expiration: string;
  collectionId?: string;
  assetId?: string;
  password?: string;
  downloadable?: boolean;
}

/**
 * Create shared link payload structure
 */
export interface CreateSharedLinkPayload {
  sharedLink: string;
}

/**
 * Response structure for createSharedLink mutation
 */
export interface CreateSharedLinkResponse {
  createSharedLink: CreateSharedLinkPayload;
}

const createSharedLink: DocumentNode = gql`
  mutation createSharedLink(
    $viewLimit: Int
    $expiration: String!
    $collectionId: String
    $assetId: String
    $password: String
    $downloadable: Boolean
  ) {
    createSharedLink(
      viewLimit: $viewLimit
      collectionId: $collectionId
      downloadable: $downloadable
      expiration: $expiration
      assetId: $assetId
      password: $password
    ) {
      sharedLink
    }
  }
`;

export default createSharedLink;
